















import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class BankAccountBody extends Vue {
  @Prop() readonly data!: any;

  utilsInstance = utils;
}
